import SignupPageExtension from "../../../@libs/Extensions/SignupPageExtension";
import required from "@libs/required";

class SignupOptionsStore extends SignupPageExtension {
	constructor(rootStore) {
		super(rootStore);
	}

	get zipcode() {
		return super.zipcode;
	}

	get serviceName() {
		return super.service.name;
	}

	get input() {
		return {
			zipcode: this.zipcode,
		};
	}

	fbCallback({ accessToken = required`accessToken` } = {}) {
		return this.signupWithFb(accessToken, this.input);
	}

	googleCallback(access_token = required`access_token`) {
		return this.signupWithGoogle(access_token, this.input);
	}
}

export default SignupOptionsStore;
